import { CFC } from "@api/types/cypress";
import React from "react";

const WarningIcon: CFC = () => (
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <defs>
      <style>{`.qls-1{fill:#fff;}.qls-2{fill: #ec2027;}`}</style>
    </defs>
    <g id="Group_1390" data-name="Group 1390">
      <g id="_circle" data-name=" circle">
        <circle id="Ellipse_67" data-name="Ellipse 67" className="qls-1" cx="32.02" cy="29.65" r="15.85" />
        <path
          id="Icon_awesome-exclamation-circle"
          data-name="Icon awesome-exclamation-circle"
          className="qls-2"
          d="M50.56,29.63A18.56,18.56,0,1,1,32,11.08h0A18.55,18.55,0,0,1,50.56,29.63ZM32,33.37a3.45,3.45,0,1,0,3.44,3.45A3.44,3.44,0,0,0,32,33.37ZM28.73,21l.56,10.18a.9.9,0,0,0,.89.85h3.64a.9.9,0,0,0,.89-.85L35.27,21a.89.89,0,0,0-.85-.94H29.63a.89.89,0,0,0-.9.89Z"
        />
      </g>
    </g>
  </svg>
);

export default WarningIcon;
